import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import TextField from '@material-ui/core/TextField';
import Form from 'react-bootstrap/Form';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import Button from 'react-bootstrap/Button';
import {
  createManuFactureHead,
  copyContractHead,
  createDrugFamilyHead,
} from './gridComponents/tableHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import {
  searchContractActions,
  getRebateProgramCode,
  getAllCopyContract,
  getAllMfgIdUsingRebateProg,
  getAllDrugFamiliesUsingMfgId,
  getContractInfo,
  dispatchDrugTable,
  dispatchGetContractInfo,
  getPopupRebateProgramCode,
} from '../store/actions';
import {
  MinDate,
  dateFormatForDatePicker,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  addDrugFamilyHead,
  drugFamilyHead,
} from './gridComponents/tableHeaddrugfamily';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { showContactTableHead } from './gridComponents/showContactTableHead';

import {
  checkQuarterValidation,
  compareQtrs,
  convertQuaterToDate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { autoFormateDate } from '../../../../SharedModules/utilities/utilities';

export default function LTCommonModal(props) {
  const {
    planTypeOptionsCreatePopup,
    onClickCreateContractDailog,
    onCloseCreateContract,
  } = props;
  const dispatch = useDispatch();
  const gridRef = React.useRef();
  const childGridRef = React.useRef();
  const [columnDefs, setColumnDefs] = React.useState(createManuFactureHead);
  const [columnDrugDefs, setDrugColumnDefs] =
    React.useState(createDrugFamilyHead);
  const [selectionPlanType, setSelectionPlanType] = React.useState('ST');
  const [dataList1, setSetDataList1] = React.useState([]);
  const [dataList2, setSetDataList2] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState({});
  const [gridApi, setGridApi] = React.useState(null);
  const [errorMessage, setErrorMessages] = React.useState([]);
  const [rebateError, showRebateError] = React.useState(false);
  const searchContractState = useSelector(
    (state) => state.sharedState.ContractReducer.searchContractState
  );
  const getRebateProgramCodeValue = (values) =>
    dispatch(getRebateProgramCode(values));

  const rebateProgramCode = useSelector(
    (state) => state.sharedState.ContractReducer?.popupRebateProgramCode?.data
  );

  const getMfgByPlanAndRpc = useSelector(
    (state) => state.sharedState.ContractReducer?.getMfgByPlanAndRpc
  );
  const getAllDrugFamiliesByMfgId = useSelector(
    (state) => state.sharedState.ContractReducer?.getAllDrugFamiliesByMfgId
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  React.useEffect(() => {
    setSelectionPlanType(searchContractState.createPlanType);
  }, [searchContractState.createPlanType]);
  React.useEffect(() => {
    if (searchContractState.createPlanType) {
      dispatch(getPopupRebateProgramCode(searchContractState.createPlanType));
    }
  }, [searchContractState.createPlanType]);
  React.useEffect(() => {
    if (getMfgByPlanAndRpc && getMfgByPlanAndRpc.length > 0) {
      const sortedData = [...getMfgByPlanAndRpc].sort((a, b) => {
        if (a.mfgId < b.mfgId) return -1;
        if (a.mfgId > b.mfgId) return 1;
        return 0;
      });
      setSetDataList1(sortedData);
    } else {
      setSetDataList1([]);
    }
  }, [getMfgByPlanAndRpc]);
  React.useEffect(() => {
    if (getAllDrugFamiliesByMfgId && getAllDrugFamiliesByMfgId.length > 0) {
      setSetDataList2(getAllDrugFamiliesByMfgId);
    } else {
      setSetDataList2([]);
    }
  }, [getAllDrugFamiliesByMfgId]);
  const onSelectionChanged = useCallback(
    (val) => {
      const selectedRows = val.api.getSelectedRows();
    },
    [gridApi]
  );
  const onSelectionMfgChanged = (val) => {
    const selectedRows = val.api.getSelectedRows();
    setSelectedRow(selectedRows[0]);
    dispatch(
      searchContractActions({
        ...searchContractState,
        selectedRowData: selectedRows[0].mfgId,
        selectedMfgName: selectedRows[0].mfgName,
      })
    );
    const error = errorMessage.filter(
      (e) => e !== constantMessageData.CONTRACT_NOT_SELECTED_ROW
    );
    setErrorMessages(error);

    if (searchContractState.createPlanType !== 'ST') {
      handleClearFilterForChild();
      dispatch(
        getAllDrugFamiliesUsingMfgId({
          mfgId: selectedRows[0].mfgId,
        })
      );
    }
  };
  // );
  const handleOnPlanChangeEvent = (value, name) => {
    if (name === 'createPlanTypeCd') {
      setSetDataList1([]);
      dispatch(
        searchContractActions({
          ...searchContractState,
          createPlanType: value,
          createRebateProgramCode: '-1',
        })
      );
    }
  };

  const onSelectManufacturerCheckBox = () => {
    let newObj = [];
    newObj =
      dataList2 &&
      dataList2.length > 0 &&
      dataList2
        ?.filter((x) => {
          return x.value;
        })
        ?.map((prop) => {
          return {
            brandName: prop.brandName,
            familyDescr: prop.familyDescr,
            drugfamilyname: prop.familyName,
            familySeqNum: prop.familySeqNum,
            alreadyAdded: false,
            mfgId: prop.mfgId,
            mfgName: prop.mfgName,
            mfgTypeCd: prop.mfgTypeCd,
            corrLinkId: null,
            endQtrErr: false,
            startQtrErr: false,
          };
        });
    return newObj;
  };
  // click on filter icon after call
  const handleClearFilter = () => {
    if (gridRef?.current) {
      gridRef.current.clearFilters();
    }
  };
  // click on filter icon after call
  const handleClearFilterForChild = () => {
    if (childGridRef?.current) {
      childGridRef.current.clearFilters();
    }
  };
  const frameworkComponents = {
    CheckBox: (cellInfo) => {
      return (
        <>
          <div className="tbl-checkbox flex">
            <FormControlLabel
              control={<Checkbox color="primary" />}
              onClick={(e) => {
                const { checked } = e.target;
                const { colId } = cellInfo.column;
                cellInfo.node.setDataValue(colId, checked);
              }}
              checked={cellInfo.value}
              value={cellInfo.value}
              data-testid="checkBox_selected"
            />
          </div>
        </>
      );
    },
  };
  const onOk = () => {
    let selectedDrugFamily = {};
    if (searchContractState.createPlanType !== 'ST') {
      selectedDrugFamily = onSelectManufacturerCheckBox();
    }
    let error = [];

    if (searchContractState.createRebateProgramCode === '-1') {
      const error1 = errorMessage.filter(
        (e) => e !== constantMessageData.CONTRACT_NOT_SELECTED_ROW
      );
      error = [
        ...new Set([
          ...error1,
          constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
        ]),
      ];
      showRebateError(true);
    } else if (
      selectedDrugFamily &&
      selectedDrugFamily.length > 0 &&
      searchContractState.createPlanType !== 'ST'
    ) {
      error = errorMessage.filter(
        (e) => e !== constantMessageData.CONTRACT_NOT_SELECTED_ROW
      );
      const data = {
        ...searchContractState,
        rebateProgramCode: searchContractState.rebateProgramCode,
        selectedCreateMfgRowData: selectedDrugFamily,
        contractType: 'CreateContract',
      };
      dispatch(searchContractActions(data));
      dispatch(dispatchDrugTable(selectedDrugFamily, '', '', 'onLoad'));
      onClickCreateContractDailog();
    } else if (
      searchContractState?.selectedRowData &&
      Object.keys(searchContractState?.selectedRowData).length > 0 &&
      searchContractState.createPlanType == 'ST'
    ) {
      const data = {
        ...searchContractState,
        rebateProgramCode: searchContractState.rebateProgramCode,

        contractType: 'CreateContract',
      };
      dispatch(searchContractActions(data));
      onClickCreateContractDailog();
    } else {
      error = [
        ...new Set([
          ...errorMessage,
          constantMessageData.CONTRACT_NOT_SELECTED_ROW,
        ]),
      ];
    }
    setErrorMessages(error);
  };
  const onBlurField = (e, name) => {
    let error = [];
    let error1 = [];
    if (name === 'rebateProgramCde') {
      const err = e.target.value === '-1';
      showRebateError(err);
      const errorShown = [...errorMessage];
      error =
        e.target.value === '-1'
          ? [
              ...new Set([
                ...errorMessage,
                constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
              ]),
            ]
          : errorShown.filter(
              (e) => e !== constantMessageData.REBATE_PROGRAM_REQUIRED_REQ
            );
      error1 = error.filter(
        (e) => e !== constantMessageData.CONTRACT_NOT_SELECTED_ROW
      );
    }
    setErrorMessages(error1);
  };
  const onClose = () => {
    onCloseCreateContract();
  };
  return (
    <div className="lt-common-modal" data-testid="LtCommonModal">
      <DisplayErrorMessages errorMessages={errorMessage} />
      <div className="p-3">
        <div className="row mb-2">
          <div className="col-8">
            <RadioGroupComponent
              labelName="Plan Type"
              id="createPlanType"
              data-testid="createPlanType"
              required
              optionList={planTypeOptionsCreatePopup || []}
              filterAction={(e) => {
                handleOnPlanChangeEvent(e, 'createPlanTypeCd');
              }}
              defaultValue={searchContractState.createPlanType}
              value={searchContractState.createPlanType}
            />
          </div>
          <div className="col-4">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="rebateProgram"
                className="mandate-fields"
                label="Rebate Program"
                required
                data-testid="rebateProgram"
                fullWidth
                select
                placeholder=""
                InputProps={{
                  id: 'rebateProgram',
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                name="rebateProgramCde"
                value={
                  searchContractState.createRebateProgramCode
                    ? searchContractState.createRebateProgramCode
                    : '-1'
                }
                onChange={(e) => {
                  dispatch(
                    searchContractActions({
                      ...searchContractState,
                      createRebateProgramCode: e.target.value,
                    })
                  );
                  dispatch(
                    getAllMfgIdUsingRebateProg({
                      planType: searchContractState.createPlanType,
                      // rebateProgramCD: e.target.value,
                    })
                  );
                  // handleClearFilter();
                  handleClearFilterForChild();
                }}
                onBlur={(e) => {
                  onBlurField(e, 'rebateProgramCde');
                }}
                helperText={
                  rebateError
                    ? constantMessageData.REBATE_PROGRAM_REQUIRED_REQ
                    : null
                }
                error={
                  rebateError
                    ? constantMessageData.REBATE_PROGRAM_REQUIRED_REQ
                    : null
                }
              >
                <MenuItem
                  key=""
                  value="-1"
                  className="frr-dropdown-blank-item"
                />
                {rebateProgramCode && rebateProgramCode.length > 0
                  ? rebateProgramCode?.map((item) => {
                      return (
                        <MenuItem
                          key={item.rebateProgramCd}
                          value={item.rebateProgramCd}
                        >
                          {item.rebateProgramCd} - {item.shortDescr}
                        </MenuItem>
                      );
                    })
                  : null}
              </TextField>
            </div>
          </div>
          <div className="clearfix" />
        </div>
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
          <TableGrid
            gridHeight={350}
            ref={gridRef}
            data-testid="contract-search-table"
            rowData={dataList1}
            columnDefs={columnDefs}
            rowSelection="multiple"
            setSelectedRow={setSelectedRow}
            // cellClickedListener={cellClickedListener}
            navigateToNextCell={navigateToNextCell}
            // helpMessage="* On Double Click of Results, system should navigate to Detail page"
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            childPopup
            onCellFocused={onCellFocused}
            onSelectionChanged={onSelectionMfgChanged}
            applyFilter={false}
            fileName="Contract Search-Manufacturer"
            exportFile
          />
        </div>
      </div>

      {searchContractState.createPlanType !== 'ST' && (
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
          <TableGrid
            ref={childGridRef}
            gridHeight={250}
            noGlobalSort
            data-testid="contract-search-table"
            rowData={dataList2}
            columnDefs={columnDrugDefs}
            rowSelection="multiple"
            setSelectedRow={setSelectedRow}
            // cellClickedListener={cellClickedDrugListener}
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            childPopup
            onCellFocused={onCellFocused}
            onSelectionChanged={onSelectionChanged}
            applyFilter={false}
            fileName="Contract Search-Drug Family"
            frameworkComponents={frameworkComponents}
            exportFile
          />
        </div>
      )}
      <div className="float-right">
        <div className="btn-wrapper my-2 mx-auto">
          <div className="float-right hide-on-print">
            <Button
              onClick={onOk}
              className="btn btn-success btn-search mr-2"
              data-testid="filter-search-add-ndc-modal-add-btn"
            >
              <SVGComponent iconName="Icon_awesome-check-circle" />
              Ok
            </Button>
            <Button
              onClick={onClose}
              className="btn btn-cancel btn-primary mr-2"
              data-testid="filter-search-add-ndc-modal-cancel-btn"
              color="primary"
              autoFocus
            >
              <SVGComponent iconName="Icon-cancel" />
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export const WriteOffPopUp = (props) => {
  const { onChangeDateField, validateDateFormatOnBlur, mfgName, rebateName } =
    props;
  const detailTab = useSelector(
    (state) =>
      state?.sharedState?.ContractReducer?.maintainContractState?.detailTab
  );

  return (
    <div className="lt-common-modal" data-testid="WriteOffPopUp">
      <div className="">
        <div className="d-flex flex-column my-2 text-left">
          <p>
            You have requested to write off all contracts for the manufacturer:{' '}
            {mfgName}
          </p>
          <p>
            This will forgive any outstanding balances due under active
            contracts with this rebate program {rebateName} . The present window
            will be SAVED automatically.
          </p>
          <p>If this is correct, enter the write off date and press OK.</p>
          <div className="clearfix" />
        </div>
        <div className="row">
          <div className="col-3">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                data-testid="writeOff1"
                className="mandate-fields"
                id="writeOffDatePop"
                label="Write Off date"
                format={dateFormatForDatePicker}
                inputFormat={dateFormatForDatePicker}
                mask="__/__/____"
                minDate={MinDate}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: false,
                  autoFill: false,
                  id: 'writeOffDatePop',
                }}
                placeholder="mm/dd/yyyy"
                value={detailTab.writeOffDatePop}
                onChange={(d) => {
                  onChangeDateField(d, 'writeOffDatePop');
                }}
                onBlur={(e) => {
                  validateDateFormatOnBlur(e, 'writeOffDatePop');
                }}
                onKeyDown={async (e) => {
                  if (e.keyCode == 67) {
                    // copy date
                    await window.navigator?.clipboard.writeText(
                      e?.target?.value
                    );
                  }
                }}
                KeyboardButtonProps={{
                  'aria-label': 'write Off',
                }}
                helperText={
                  detailTab.errorInvalidWirteOffDatePop
                    ? constantMessageData.WRITE_OFF_DATE_INVALID
                    : null
                }
                error={
                  detailTab.errorInvalidWirteOffDatePop
                    ? constantMessageData.WRITE_OFF_DATE_INVALID
                    : null
                }
              />
            </MuiPickersUtilsProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export const UndoWriteOffPopUp = (props) => {
  const { mfgName, rebateName, writeOffDate } = props;
  return (
    <div className="lt-common-modal" data-testid="UndoWriteOffPopUp">
      <div className="">
        <div className="d-flex flex-column my-2 text-left">
          <p>
            You have requested to remove write off date of {writeOffDate} for
            Manufacturer
          </p>

          <p>
            {mfgName} and {rebateName}
          </p>

          <p>
            This will remove the write offs on all contracts and invoices for
            this Manufacturer and Rebate Program
          </p>
          <p>Press OK to proceed.</p>
          <div className="clearfix" />
        </div>
      </div>
    </div>
  );
};

export const CopyContractModal = (props) => {
  // const { onChangeDateField, validateDateFormatOnBlur } = props;
  const dispatch = useDispatch();
  const getAllCopyContractData = useSelector(
    (state) => state.sharedState.ContractReducer.getAllCopyContractData
  );
  const [columnDefs, setColumnDefs] = React.useState(copyContractHead);
  const [loading, setLoading] = React.useState(false);
  const gridRef = React.useRef();
  const [copyContractTable, setCopyContractTable] = React.useState(false);
  React.useEffect(() => {
    setLoading(true);
    dispatch(
      getAllCopyContract({
        contactSeqNum: 2,
        mfgId: '00002',
        showAllInd: false,
      })
    );
  }, []);
  const handleClearFilter = () => {
    if (gridRef?.current) {
      gridRef.current.clearFilters();
    }
  };
  React.useEffect(() => {
    if (getAllCopyContractData && getAllCopyContractData.length > 0) {
      handleClearFilter();
      setLoading(false);
      // xlet data = { ...invoiceContact };
      // let newdata = {
      //   ...maintainContractState,
      //   invoiceContact: {
      //     ...invoiceContact,
      //     copyContractData: getAllCopyContractData || []
      //   },
      // };
      // dispatch(maintainContractActions(newdata));
      setCopyContractTable(getAllCopyContractData);
    }
  }, [getAllCopyContractData]);

  return (
    <div className="lt-common-modal" data-testid="CopyContractModal">
      <Spinner load={loading} />
      <div className="p-3">
        <div className="row mb-2">
          <div className="col-12">
            <FormControlLabel
              control={
                <Checkbox style={{ marginRight: '5px' }} color="primary" />
              }
              data-testid="ShowALl"
              label="Show All"
              // checked={
              //   values.usedDrugRebate === 0 ? false : true
              // }
              // value={values.usedDrugRebate === 0 ? 0 : 1}
              // onChange={(e) => {
              //   let newObj = { ...values };
              //   newObj.usedDrugRebate =
              //     values.usedDrugRebate === 0 ? 1 : 0;
              //   setValues(newObj);
              //   let data = {
              //     ...maintainCheckRequest,
              //     usedDrugRebate : newObj.usedDrugRebate
              //   }
              //   dispatch(maintainCheckReqAction(data));
              //   setHasChanges(true);
              // }}
            />
          </div>
          <div className="clearfix" />
        </div>

        <TableGrid
          ref={gridRef}
          gridHeight={400}
          data-testid="contract-search-table"
          rowData={copyContractTable}
          columnDefs={columnDefs}
          rowSelection="multiple"
          // setSelectedRow={setSelectedRow}
          // fullScreenView={fullScreenView}
          // handleFullScreenViewClick={handleFullScreenView}
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          childPopup
          onCellFocused={onCellFocused}
          // onSelectionChanged={onSelectionChanged}
          applyFilter={false}
          fileName="Contract Search"
          // frameworkComponents={frameworkComponents}
          exportFile
        />
      </div>
    </div>
  );
};

export function AddDrugFamily(props) {
  const { onClickCreateContractDailog, onCloseCreateContract } = props;
  const dispatch = useDispatch();
  const gridRef = React.useRef();
  const [columnDrugDefs, setDrugColumnDefs] = React.useState(addDrugFamilyHead);

  const [dataList2, setSetDataList2] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState({});
  const [gridApi, setGridApi] = React.useState(null);
  const [gridParams, setGridParams] = React.useState('');

  const getAllDrugFamiliesByMfgId = useSelector(
    (state) => state.sharedState.ContractReducer?.getAllDrugFamiliesByMfgId
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const getAllContractData = useSelector(
    (state) => state.sharedState?.ContractReducer?.getAllContractData
  );
  React.useEffect(() => {
    if (getAllDrugFamiliesByMfgId && getAllDrugFamiliesByMfgId.length > 0) {
      setSetDataList2(getAllDrugFamiliesByMfgId);
    } else {
      setSetDataList2([]);
    }
  }, [getAllDrugFamiliesByMfgId]);
  const onSelectionChanged = (val) => {
    const selectedRows = val.api.getSelectedRows();
    setSelectedRow(selectedRows[0]);
  };

  const onGridReady = useCallback((params) => {
    setGridParams(params);
    params.api.forEachNode((node) =>
      node.rowIndex ? 1 : node.setSelected(true)
    );
  });
  const cellClickedListener = (e) => {
    setSelectedRow(e?.data);
  };
  const onOk = () => {
    onClickCreateContractDailog(selectedRow);
  };
  const onClose = () => {
    onCloseCreateContract();
  };
  const handleClearFilter = () => {
    if (gridRef?.current) {
      gridRef.current.clearFilters();
    }
  };
  React.useEffect(() => {
    dispatch(
      getAllDrugFamiliesUsingMfgId({
        mfgId:
          searchContractState.contractType === 'onSelect'
            ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                ?.mfgId
            : searchContractState.selectedRowData,
      })
    );
    handleClearFilter();
  }, []);
  return (
    <div className="lt-common-modal" data-testid="AddDrugFamily">
      <div className="p-3">
        {/* {dataList2 && dataList2.length > 0 && */}
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
          <TableGrid
            ref={gridRef}
            gridHeight={350}
            data-testid="contract-search-table"
            rowData={dataList2}
            onGridReady={onGridReady}
            columnDefs={columnDrugDefs}
            rowSelection="multiple"
            setSelectedRow={setSelectedRow}
            // cellClickedListener={cellClickedListener}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            childPopup
            onCellFocused={onCellFocused}
            onSelectionChanged={onSelectionChanged}
            applyFilter={false}
            fileName="Maintain Contract-Drug Family"
            exportFile
          />
        </div>
        {/* } */}
      </div>
      <div className="float-right">
        <div className="btn-wrapper my-2 mx-auto">
          <div className="float-right hide-on-print">
            <Button
              onClick={onOk}
              className="btn btn-success btn-search mr-2"
              data-testid="filter-search-add-ndc-modal-add-btn"
            >
              <SVGComponent iconName="Icon_awesome-check-circle" />
              Ok
            </Button>
            <Button
              onClick={onClose}
              className="btn btn-cancel btn-primary mr-2"
              data-testid="filter-search-add-ndc-modal-cancel-btn"
              color="primary"
              autoFocus
            >
              <SVGComponent iconName="Icon-cancel" />
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export const DuplicateDrugFamily = (props) => {
  const { onCloseCreateContract, onClickOkDuplicateButton } = props;
  const [startQtr, setStartQtr] = React.useState('');
  const [errorQtr, setErrorQtr] = React.useState(false);
  const [errorQtrReq, setErrorQtrReq] = React.useState(false);
  const [errorQtrOverlap, setErrorQtrOverlap] = React.useState(null);

  const getDrugFamilyTable = useSelector(
    (state) => state.sharedState.ContractReducer.getDrugFamilyTable
  );

  const selectedRowDetails = useSelector(
    (state) => state.sharedState.ContractReducer.selectedRowDetails
  );

  const onChangeDetailsField = (e, name) => {
    setStartQtr(e.target.value);
  };

  const doQuartersOverlap = (dates) => {
    let myArr = [...dates];
    myArr = myArr.map((el) => {
      if (!el.endquarter) {
        return {
          ...el,
          startquarter: new Date(el.startquarter),
          endquarter: new Date('12/31/9999'),
        };
      }
      return {
        ...el,
        startquarter: new Date(el.startquarter),
        endquarter: new Date(el.endquarter),
      };
    });
    let overlap = [];

    for (let i = 0; i < myArr.length; i += 1) {
      for (let j = i + 1; j < myArr.length; j += 1) {
        // Check if the date ranges overlap
        if (
          myArr[i].drugfamilyname === myArr[j].drugfamilyname &&
          myArr[i].startquarter <= myArr[j].endquarter &&
          myArr[j].startquarter <= myArr[i].endquarter
        ) {
          // Add the indexes of the overlapping objects to the array
          overlap.push(i, j);
        }
      }
    }
    return (overlap = [...new Set(overlap)]);
  };
  const onBlurQuarter = (e, name) => {
    const dateFromPicker = autoFormateDate(e.target.value?.toUpperCase());
    setStartQtr(dateFromPicker);
    if (e.target.value === '') {
      setErrorQtrReq(true);
      setErrorQtr(false);
    } else if (!checkQuarterValidation(dateFromPicker)) {
      setErrorQtr(true);
      setErrorQtrReq(false);
    } else {
      setStartQtr(dateFromPicker);
      setErrorQtr(false);
      setErrorQtrReq(false);
      const regexNumber = /^[0-9/]+$/;
      const fieldName = drugFamilyHead?.map((data) => data.field);
      const drugFamily = {};
      fieldName.forEach((li) => {
        if (li === 'startquarter' || li === 'endquarter') {
          drugFamily.startquarter = dateFromPicker;
          drugFamily.endquarter = '4Q9999';
          drugFamily.drugfamilyname = selectedRowDetails;
        } else {
          drugFamily[li] = '';
        }
      });
      const newObj = [...getDrugFamilyTable, drugFamily];
      // overlap validation
      let tempArr = [...newObj];
      tempArr = tempArr?.map((el) => {
        return {
          ...el,
          startquarter: convertQuaterToDate(el.startquarter),
          endquarter: convertQuaterToDate(el.endquarter),
        };
      });

      const quarterOverlap = doQuartersOverlap(tempArr);
      if (quarterOverlap.length > 0) {
        let msg = '';
        quarterOverlap.forEach((li, index) => {
          msg += `Row ${li + 1} ${
            quarterOverlap.length !== index + 1 ? ' and ' : ''
          }`;
        });
        setErrorQtrOverlap(`${'Start and End Date Overlap on'} ${msg}.`);
        return;
      }
      setErrorQtrOverlap(null);

      if (dateFromPicker.includes('Q') || dateFromPicker.includes('q')) {
        const dateUpperCase = dateFromPicker.toUpperCase();
        const splitYear = dateUpperCase.split('Q') || dateUpperCase.split('q');
        const checkQuater = splitYear[0] <= 4;
        if (checkQuater) {
          if (
            dateFromPicker.length === 6 &&
            regexNumber.test(splitYear[1]) &&
            splitYear[1] >= 1991 &&
            splitYear[1] <= 9999
          ) {
            setStartQtr(e.target.value);
            setErrorQtr(false);
            setErrorQtrReq(false);
          } else if (
            dateFromPicker.length === 4 &&
            regexNumber.test(splitYear[1])
          ) {
            setStartQtr(e.target.value);
            setErrorQtr(false);
            setErrorQtrReq(false);
          } else {
            setStartQtr(e.target.value);
            setErrorQtr(true);
            setErrorQtrReq(false);
          }
        } else {
          setStartQtr(e.target.value);
          setErrorQtr(true);
          setErrorQtrReq(false);
        }
      } else if (dateFromPicker === '') {
        setStartQtr(e.target.value);
        setErrorQtr(false);
        setErrorQtrReq(false);
      } else {
        setStartQtr(e.target.value);
        setErrorQtr(true);
        setErrorQtrReq(false);
      }
    }
  };
  const onOk = () => {
    if (startQtr === '') {
      setErrorQtrReq(true);
    } else if (startQtr !== '' && errorQtr) {
      setErrorQtr(true);
    } else if (!errorQtrOverlap) {
      onClickOkDuplicateButton(startQtr);
    }
  };
  const onClose = () => {
    onCloseCreateContract();
  };
  return (
    <div className="lt-common-modal" data-testid="DuplicateDrugFamily">
      <div className="p-3">
        <div className="mui-custom-form input-md">
          <TextField
            data-testid="Quarter"
            id="Quarter"
            label="Start Quarter"
            className="mandate-fields"
            fullWidth
            required
            placeholder=""
            inputProps={{ maxLength: 38, id: 'Quarter' }}
            InputLabelProps={{
              shrink: true,
            }}
            value={startQtr}
            onChange={(e) => {
              onChangeDetailsField(e, 'startQtr');
            }}
            onBlur={(e) => {
              onBlurQuarter(e, 'startQtr');
            }}
            helperText={
              errorQtr
                ? constantMessageData.QUARTER_FORMAT_ERROR
                : errorQtrReq
                ? constantMessageData.CONTRACT_START_QTR
                : errorQtrOverlap || null
            }
            error={
              errorQtr
                ? constantMessageData.QUARTER_FORMAT_ERROR
                : errorQtrReq
                ? constantMessageData.CONTRACT_START_QTR
                : errorQtrOverlap || null
            }
          />
        </div>
      </div>
      <div className="float-right">
        <div className="btn-wrapper my-2 mx-auto">
          <div className="float-right hide-on-print">
            <Button
              onClick={onOk}
              className="btn btn-success btn-search mr-2"
              data-testid="filter-search-add-ndc-modal-add-btn"
            >
              <SVGComponent iconName="Icon_awesome-check-circle" />
              Ok
            </Button>
            <Button
              onClick={onClose}
              className="btn btn-cancel btn-primary mr-2"
              data-testid="filter-search-add-ndc-modal-cancel-btn"
              color="primary"
              autoFocus
            >
              <SVGComponent iconName="Icon-cancel" />
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export function ShowContractUsingContacts(props) {
  const { contactSeqNum } = props;
  const dispatch = useDispatch();
  const getShowContractInfo = useSelector(
    (state) => state.sharedState.ContractReducer.getShowContractInfo
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const gridRef = React.useRef();
  const [columnDrugDefs, setDrugColumnDefs] = useState(showContactTableHead);
  const [dataList2, setSetDataList2] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState({});
  const [gridApi, setGridApi] = React.useState(null);
  const [gridParams, setGridParams] = React.useState('');
  React.useEffect(() => {
    if (getShowContractInfo && getShowContractInfo.length > 0) {
      setSetDataList2(getShowContractInfo);
    } else {
      setSetDataList2([]);
    }
  }, [getShowContractInfo]);

  // handing by default 1st row selection function
  const onGridReady = useCallback((params) => {
    setGridParams(params);
  });
  // click on filter icon after call
  const handleClearFilter = () => {
    if (gridRef !== null) {
      if (gridRef.current?.clearFilters) gridRef.current.clearFilters();
      if (gridParams?.columnApi && gridParams?.columnApi !== null) {
        gridParams.columnApi.applyColumnState({
          state: [{ colId: 'contractSeqNum', sort: 'asc' }],
        });
      }
    }
  };
  React.useEffect(() => {
    if (
      gridRef.current &&
      gridRef.current.clearFilters &&
      gridParams &&
      gridParams.columnApi &&
      dataList2 &&
      dataList2.length > 0
    ) {
      handleClearFilter();
    }
  }, [gridRef, gridParams, dataList2]);
  React.useEffect(() => {
    dispatch(dispatchGetContractInfo([]));
    setSetDataList2([]);
    // setTimeout(() => {
    //   handleClearFilter();
    // }, 1500);
    if (contactSeqNum) {
      dispatch(getContractInfo({ invContactSeqNum: contactSeqNum }));
    }
  }, []);
  return (
    <div className="lt-common-modal" data-testid="ShowContractUsingContacts">
      <Spinner load={spinnerLoader} />
      <div className="p-3">
        {/* {dataList2 && dataList2.length > 0 && */}
        <TableGrid
          ref={gridRef}
          gridHeight={350}
          data-testid="contract-search-table"
          rowData={dataList2}
          onGridReady={onGridReady}
          columnDefs={columnDrugDefs}
          setSelectedRow={setSelectedRow}
          // cellClickedListener={cellClickedListener}
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          childPopup
          onCellFocused={onCellFocused}
          applyFilter={false}
          fileName="Contracts using contact"
          exportFile
        />
        {/* } */}
      </div>
    </div>
  );
}

export const DuplicateContract = (props) => {
  const { onClickDuplicateContractDailog, onCloseDuplicateContract, planType } =
    props;
  const dispatch = useDispatch();

  const getRebateProgramCodeValue = (values) =>
    dispatch(getRebateProgramCode(values));

  const rebateProgramCode = useSelector(
    (state) => state.sharedState.ContractReducer?.rebateProgramCode?.data
  );
  const [formValues, setFormValues] = useState({
    fromDate: null,
    toDate: null,
    rebateProgramCode: '-1',
    drugPricing: false,
  });
  const [errorForm, setErrorForm] = useState({
    fromDate: false,
    rebateProgramCode: false,
  });
  React.useEffect(() => {
    getRebateProgramCodeValue(planType);
  }, []);
  const onOk = () => {
    onClickDuplicateContractDailog(
      formValues.fromDate,
      formValues.toDate,
      formValues.rebateProgramCode,
      formValues.drugPricing
    );
  };
  const onClose = () => {
    onCloseDuplicateContract();
  };
  const onChangeDateField = (d, name) => {
    if (d != 'Invalid Date') {
      setFormValues({ ...formValues, [name]: d });
      setErrorForm({ ...errorForm, [name]: false });
    }
  };
  const onBlurField = (e, name) => {
    if (e.target.value === '-1') {
      setErrorForm({ ...errorForm, [name]: true });
    } else {
      setErrorForm({ ...errorForm, [name]: false });
    }
  };
  return (
    <div className="lt-common-modal" data-testid="DuplicateContract">
      <div className="p-3">
        <div className="row">
          <div className="col-11 ml-3">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                data-testid="writeOff"
                className="mandate-fields"
                id="writeOffDatePop1"
                label="Start Date"
                format={dateFormatForDatePicker}
                inputFormat={dateFormatForDatePicker}
                mask="__/__/____"
                minDate={MinDate}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: false,
                  autoFill: false,
                  id: 'writeOffDatePop1',
                }}
                onKeyDown={async (e) => {
                  if (e.keyCode == 67) {
                    // copy date
                    await window.navigator?.clipboard.writeText(
                      e?.target?.value
                    );
                  }
                }}
                placeholder="mm/dd/yyyy"
                value={formValues.fromDate}
                onChange={(d) => {
                  onChangeDateField(d, 'fromDate');
                }}
                // onBlur={(e) => {
                //   validateDateFormatOnBlur(e, 'fromDate');
                // }}
                KeyboardButtonProps={{
                  'aria-label': 'from Date',
                }}
                helperText={
                  errorForm.fromDate
                    ? constantMessageData.WRITE_OFF_DATE_INVALID
                    : null
                }
                error={
                  errorForm.fromDate
                    ? constantMessageData.WRITE_OFF_DATE_INVALID
                    : null
                }
              />
            </MuiPickersUtilsProvider>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                data-testid="writeOff2"
                className="mandate-fields"
                id="writeOffDatePop2"
                label="Start Date"
                format={dateFormatForDatePicker}
                inputFormat={dateFormatForDatePicker}
                mask="__/__/____"
                minDate={MinDate}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: false,
                  autoFill: false,
                  id: 'writeOffDatePop2',
                }}
                placeholder="mm/dd/yyyy"
                value={formValues.toDate}
                onChange={(d) => {
                  onChangeDateField(d, 'toDate');
                }}
                // onBlur={(e) => {
                //   validateDateFormatOnBlur(e, 'toDate');
                // }}
                KeyboardButtonProps={{
                  'aria-label': 'to Date',
                }}
                helperText={
                  errorForm.toDate
                    ? constantMessageData.WRITE_OFF_DATE_INVALID
                    : null
                }
                error={
                  errorForm.fromDate
                    ? constantMessageData.WRITE_OFF_DATE_INVALID
                    : null
                }
              />
            </MuiPickersUtilsProvider>
            <div className="mui-custom-form with-select">
              <TextField
                className="mandate-fields"
                label="Rebate Program"
                required
                id="rebateProgram"
                data-testid="rebateProgram"
                fullWidth
                select
                placeholder=""
                InputProps={{
                  id: 'rebateProgram',
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                name="rebateProgramCode"
                value={
                  formValues.rebateProgramCode
                    ? formValues.rebateProgramCode
                    : '-1'
                }
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    rebateProgramCode: e.target.value,
                  });
                }}
                onBlur={(e) => {
                  onBlurField(e, 'rebateProgramCode');
                }}
                helperText={
                  errorForm.rebateProgramCode
                    ? constantMessageData.REBATE_PROGRAM_REQUIRED_REQ
                    : null
                }
                error={
                  errorForm.rebateProgramCode
                    ? constantMessageData.REBATE_PROGRAM_REQUIRED_REQ
                    : null
                }
              >
                <MenuItem
                  key=""
                  value="-1"
                  className="frr-dropdown-blank-item"
                />
                {rebateProgramCode && rebateProgramCode.length > 0
                  ? rebateProgramCode.map((item) => {
                      return (
                        <MenuItem
                          key={item.rebateProgramCd}
                          value={item.rebateProgramCd}
                        >
                          {item.rebateProgramCd} - {item.shortDescr}
                        </MenuItem>
                      );
                    })
                  : null}
              </TextField>
            </div>
            <Form.Group className="col-11" controlId="formBasicCheckbox">
              <FormControlLabel
                control={<Checkbox color="primary" />}
                id="rebate-checkbox"
                data-testid="rebate_checkbox"
                label="Drug Pricing"
                checked={formValues.drugPricing}
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    drugPricing: !formValues.drugPricing,
                  });
                }}
              />
            </Form.Group>
          </div>
        </div>
        <div className="float-right">
          <div className="btn-wrapper my-2 mx-auto">
            <div className="float-right hide-on-print">
              <Button
                onClick={onOk}
                className="btn btn-success btn-search mr-2"
                data-testid="filter-search-add-ndc-modal-add-btn"
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Ok
              </Button>
              <Button
                onClick={onClose}
                className="btn btn-cancel btn-primary mr-2"
                data-testid="filter-search-add-ndc-modal-cancel-btn"
                color="primary"
                autoFocus
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
